import { useFormikContext } from "formik";
import * as Yup from "yup";
import { Stack, Typography } from "@mui/material";
import { MultiSectionDigitalClock } from "@mui/x-date-pickers/MultiSectionDigitalClock";

export const TimeFormSchema = Yup.object().shape({
  time: Yup.string().required("Campo requerido"),
});

export type ITimeForm = {
  time: Date | null;
};

export const timeFormInitialValues: ITimeForm = {
  time: null,
};

export const timeFormFields = Object.keys(timeFormInitialValues);

export const onSubmitLocationForm = async () => {
  return;
};

const TimeForm = () => {
  const formik = useFormikContext<ITimeForm>();

  return (
      <Stack spacing={3} alignItems="center">
        <Typography textAlign="center" variant="h4">¿Cuál es el horario<br/>se adapta mejor a ti?</Typography>
        <MultiSectionDigitalClock
          value={formik.values.time}
          onChange={(value) => {
            formik.setFieldValue('time', value);
          }}
          sx={{
            justifyContent: 'center'
          }}
        />
      </Stack>
  );
};

export default TimeForm;
